<template>
  <div class="guide-wrapper">
    <div class="payment-noti-wrap">
      <div class="ticket-noti-wrap">
        <p
          v-for="caution in CAUTIONS_FOR_SERVICE"
          :key="caution"
          class="dot-text"
        >
          <span v-html="getTextLinks(caution, linkObject)"></span>
        </p>
      </div>
      <input
        id="payment-noti-more"
        type="checkbox"
        class="noti-more-btn"
      /><label for="payment-noti-more"></label>

      <div class="ticket-noti-more">
        <p class="dot-text">
          <span
            >회원이 유료 결제 후 사용하지 않은 상품은 구매일 기준 7일 내 청약
            철회가 가능합니다.</span
          >
        </p>
        <p class="dot-text">
          <span
            >고객센터>1:1문의하기 메뉴를 통해 청약철회 의사를 표시할 수 있으며,
            접수일로부터 3영업일 이내 결제 취소 또는 현금 환불해 드립니다. 다만,
            각 호의 경우에는 결제취소처리가 불가능합니다.<br />
            &nbsp;&nbsp;①이벤트, 쿠폰, 보상 등 결제수단이 무료로 지급된 경우<br />
            &nbsp;&nbsp;②해당 기간 내에 사용내역이 있을 경우<br />
            &nbsp;&nbsp;③해당 결제수단에 따른 결제취소 가능기간을 경과한 경우<br
          /></span>
        </p>
        <p class="dot-text">
          <span
            >만 20세 미만의 미성년자의 유료서비스 이용은 법정대리인이 이를
            취소할 수 있습니다. (단, 결제 수단의 명의자가 성년인 경우에는 취소
            제한)</span
          >
        </p>
      </div>
      <div class="ticket-noti-wrap">
        <template v-for="text in PROMOTION_TEXT">
          <p v-if="isMobileWebOnly" :key="text" class="dot-text">
            <span>{{ text }}</span>
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import utils from '@/common/util/utils'
  import { isApp } from '@/common/util/common'
  import {
    CAUTIONS_FOR_SERVICE,
    CAUTIONS_FOR_SERVICE_LINK_APP,
    CAUTIONS_FOR_SERVICE_LINK_WEB,
    PROMOTION_TEXT,
  } from '@/components/lnb/voucher/voucher-text/const'
  import { getTextLinks } from '@/common/util/string-manipulation/get-text-links'

  const linkObject = computed(() =>
    isApp() ? CAUTIONS_FOR_SERVICE_LINK_APP : CAUTIONS_FOR_SERVICE_LINK_WEB,
  )
  const isMobileWebOnly = computed(() => utils.cookies.getDevice() === 'mobile')
</script>

<style lang="scss" scoped>
  .guide-wrapper {
    margin-bottom: 120px;
  }
</style>
